import React, { useEffect, useState } from "react";
import { Rate, Typography } from "antd";
import { CloseOutlined, RocketOutlined } from "@ant-design/icons";
import FeedbackModal from "../Modals/FeedbackModal";
import { sellBoostFetch } from "../../utlifyFunction";

const { Paragraph } = Typography;

const FeedbackBanner = () => {
	const [visible, setVisible] = useState();
	const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);

	const handleRate = async (value) => {
		if (value <= 3) {
			setIsFeedbackModalOpen(value);
		} else {
			window.open(
				"https://apps.shopify.com/sellboost-ai#modal-show=WriteReviewModal",
				"_blank"
			);
		}
	};

	const fetchReview = async () => {
		const data = await sellBoostFetch("GET", "/user/review");
		if (!data?.isReviewAdded) {
			setVisible(true);
		}
	};

	useEffect(() => {
		fetchReview();
	}, []);

	return (
		<>
			{visible && (
				<div
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "space-between",
						padding: "12px 16px",
						borderRadius: "8px",
						background: "#F3F5FF",
						border: "1px solid #6D5BBA",
						color: "#6D5BBA",
					}}
				>
					<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
						<RocketOutlined style={{ fontSize: "18px", color: "#6D5BBA" }} />
						<Paragraph
							style={{
								margin: 0,
								fontSize: "14px",
								fontWeight: 500,
								color: "#6D5BBA",
							}}
						>
							How would you rate your experience?
						</Paragraph>
						<Rate onChange={handleRate} style={{ color: "#6D5BBA" }} />
					</div>
					<CloseOutlined
						onClick={() => setVisible(false)}
						style={{ cursor: "pointer", color: "#6D5BBA" }}
					/>
				</div>
			)}

			{/* Feedback Modal */}
			<FeedbackModal
				setVisible={setVisible}
				isFeedbackModalOpen={isFeedbackModalOpen}
				setIsFeedbackModalOpen={setIsFeedbackModalOpen}
			/>
		</>
	);
};

export default FeedbackBanner;
